<template>
  <div class="swiper-slide">
    <div class="wap_index6 main">
      <div class="wap_index6_title">合作流程①</div>
      <div class="wap_index600_main">
        <div class=""></div>
      </div>
      <div class="wap_index6_main">
        <div v-for="(item, index) in flowList" :key="index">
          <div :class="`wap_index6_main_bg${index + 1}`"></div>
          <div>{{ item.title }}</div>
          <div>{{ item.info }}</div>
          <div>0{{ index + 1 }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      flowList: [
        {
          title: "选择版本",
          info: "我们为开发者提供众多完成度100%的千年底板供您选择",
        },
        {
          title: "个性化定制",
          info: "如您对已选版本有个性化需求，我们将评估开发者提出的个性化需求，并给出完成周期",
        },
        {
          title: "签署合作协议，支付保证金",
          info: "签署合作协议并支付保证金后我们将为您搭建专属服务器和配套运营工具，用于版本调整",
        },
        {
          title: "版本需求",
          info: "我们将为您的专属游戏服务器完成版本调试，个性化需求开发",
        },
        {
          title: "游戏交付",
          info: "交付给您已选游戏的最终版本和配套运营+运维工具",
        },
        {
          title: "正式上线",
          info: "正式上线后我们将持续辅助您做好正式上线后的游戏运营，推广，后续版本迭代服务",
        },
      ], // 合作流程内容
    };
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.wap_index6 {
  background-image: url("../../assets/images/web/cooperation.jpg");
}

.wap_index6_main {
  width: 90%;
  width: 9.2rem /* 345/37.5 */;
  border-radius: 0.4rem /* 15/37.5 */;
  box-sizing: border-box;
  border: 1px solid #707070;
  display: flex;
  flex-wrap: wrap;
  margin: 0 auto;
  padding: 0.453333rem /* 17/37.5 */ 0;
}
.wap_index6_main > div {
  margin: 0 auto;
  width: 45%;
  border-radius: 0.133333rem /* 5/37.5 */;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #575757;
  margin-bottom: 0.4rem /* 15/37.5 */;
  box-sizing: border-box;
  padding: 0 0.24rem /* 9/37.5 */;
  padding-top: 0.213333rem /* 8/37.5 */;
}
.wap_index3-ul {
  color: #fff !important;
}
.wap_index6_main > div > div:nth-child(2) {
  font-size: 0.346667rem /* 13/37.5 */;
  color: #fff;
  font-weight: bold;
  padding: 0.24rem /* 9/37.5 */ 0;
}
.wap_index6_main > div > div:nth-child(3) {
  font-size: 0.32rem /* 12/37.5 */;
  height: 1.6rem /* 60/37.5 */;
  color: #b1b1b1;
}
.wap_index6_main > div > div:nth-child(4) {
  font-size: 0.693333rem /* 26/37.5 */;
  color: #707070;
  font-weight: bold;
}
.wap_index6_main > div:nth-child(5) {
  margin-bottom: 0;
}
.wap_index6_main > div:nth-child(6) {
  margin-bottom: 0;
}
.wap_index6_main_bg1 {
  width: 0.746667rem /* 28/37.5 */;
  height: 0.746667rem /* 28/37.5 */;
  background: url("../../assets/images/web/6001.png") no-repeat center;
  background-size: cover;
  background-size: cover;
}
.wap_index6_main_bg2 {
  width: 0.746667rem /* 28/37.5 */;
  height: 0.746667rem /* 28/37.5 */;
  background: url("../../assets/images/pc/flow2.png") no-repeat center;
  background-size: cover;
}
.wap_index6_main_bg3 {
  width: 0.88rem /* 33/37.5 */;
  height: 0.746667rem /* 28/37.5 */;
  background: url("../../assets/images/pc/flow3.png") no-repeat center;
  background-size: cover;
}
.wap_index6_main_bg4 {
  width: 0.853333rem /* 32/37.5 */;
  height: 0.746667rem /* 28/37.5 */;
  background: url("../../assets/images/web/6003.png") no-repeat center;
  background-size: cover;
}
.wap_index6_main .wap_index6_main_bg5 {
  width: 0.746667rem /* 28/37.5 */;
  height: 0.666667rem /* 25/37.5 */;
  background: url("../../assets/images/web/6002.png") no-repeat center;
  background-size: cover;
}
.wap_index6_main_bg6 {
  width: 0.746667rem /* 28/37.5 */;
  height: 0.666667rem /* 25/37.5 */;
  background: url("../../assets/images/pc/flow6.png") no-repeat center;
  background-size: cover;
}
@media (max-width: 750px) and (max-height: 667px) {
  .wap_index6_main {
    padding: 0.266667rem /* 10/37.5 */ 0;
  }
  .wap_index6_main > div:nth-child(5) {
    margin-bottom: 0;
  }
  .wap_index6_main > div:nth-child(6) {
    margin-bottom: 0;
  }
  .wap_index6_main > div > div:nth-child(2) {
    font-size: 0.32rem /* 12/37.5 */;
    padding: 0.133333rem /* 5/37.5 */ 0;
  }
  .wap_index6_main > div {
    width: 44%;
    border-radius: 0.133333rem /* 5/37.5 */;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #575757;
    margin-bottom: 0.266667rem /* 10/37.5 */;
    box-sizing: border-box;
    padding: 0 0.24rem /* 9/37.5 */;
    padding-top: 0.213333rem /* 8/37.5 */;
  }
  .wap_index6_main > div > div:nth-child(4) {
    font-size: 0.48rem /* 18/37.5 */;
  }
}

@media (max-width: 750px) and (max-height: 600px) {
  .wap_index6_main {
    padding: 0.16rem /* 6/37.5 */ 0;
  }
  .wap_index6_main > div {
    margin: 0 auto;
    width: 47%;
    padding-top: 0.106667rem /* 4/37.5 */;
  }
  .wap_index6_main > div > div:nth-child(2) {
    padding: 0;
  }
  .wap_index6_main > div:nth-child(5) {
    margin-bottom: 0;
  }
  .wap_index6_main > div:nth-child(6) {
    margin-bottom: 0;
  }
  .wap_index6_main > div > div:nth-child(3) {
    font-size: 0.266667rem /* 10/37.5 */;
  }
  .wap_index6_main > div > div:nth-child(4) {
    font-size: 0.48rem /* 18/37.5 */;
    font-size: 0.373333rem /* 14/37.5 */;
  }
  .wap_index6_main > div {
    margin-bottom: 0.16rem /* 6/37.5 */;
  }
}
</style>
